import api from '@/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCancelOrderMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['cancel-order'],
    mutationFn: (id: string) => api.order.cancel(id),
    onSuccess: (data, orderId) => {
      queryClient.invalidateQueries({
        queryKey: ['orders'],
      });
    },
  });
}
